module.exports = __webpack_public_path__ + "static/img/cont58_03.8d07ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_03.jpg
// module id = zGt+
// module chunks = 0